<div class="rfid-card">

    <sc-master-detail [selection]="[selectedRFIDCard]" [data]="rfidCards" [newStyle]="true"
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
        (deleteEntry)="onDeleteEntry($event);">

        <sc-scroll-pane>
            <form class="form" [formGroup]="formGroup">
                <sc-padding>
                    <sc-flex vertical stretchContent *ngIf="workingCopyDetails"
                        class="no-field-space">
                        <mat-form-field appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.number.label"></sc-dictionary-label>
                          </mat-label>
                            <input formControlName="nbr" name="nbr" matInput
                                [required]="true" [maxlength]="255" />
                        </mat-form-field>
                        <sc-content-spacer vertical></sc-content-spacer>
                        <mat-form-field appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.description.label"></sc-dictionary-label>
                          </mat-label>
                            <textarea formControlName="description" name="description" matInput
                                [required]="false" [maxlength]="1024"></textarea>
                        </mat-form-field>
                        <sc-content-spacer vertical></sc-content-spacer>
                        <mat-checkbox formControlName="active" name="active">
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.active.label"></sc-dictionary-label>
                        </mat-checkbox>
                        <sc-content-spacer vertical></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.valid-from.label"></sc-dictionary-label>
                            </mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="validFrom" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer vertical></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.valid-until.label"></sc-dictionary-label>
                            </mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="validUntil" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </sc-flex>
                </sc-padding>
            </form>
        </sc-scroll-pane>

        <ng-template masterDetailToolbar>
              <sc-cancel-button class="config-changed-button" (click)="cancel()"
              [disabled]="!cancelEnabled"></sc-cancel-button>
            <sc-content-spacer></sc-content-spacer>
            <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
        </ng-template>

    </sc-master-detail>

</div>
